// src/cert/iso45001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO45001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 45001 प्रमाणन</h1>
                <p>व्यावसायिक आरोग्य व सुरक्षा व्यवस्थापन प्रणाली (OH&S Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 45001 म्हणजे काय?</h2>
                    <p>
                        The ISO 9001 standard requirements are generic and are intended to be applicable to any type of organization, regardless of its type or size, or the products and services it provides. World first ISO standards which is most acceptable in market globally.
                        ISO 9001:2015 Quality Management System (QMS) is internationally recognized as the world’s leading quality management standard and has been implemented by over one million organizations in over 170 countries globally. ISO 9001 implemented, to its full potential, becomes an invaluable asset to your organization.
                        The purpose of the standard is to assist companies in meeting statutory and regulatory requirements relating to their product while achieving excellence in their customer service and The standard can be used throughout an organization to improve the performance or within a particular site, plant or department.
                        ISO 9001 contains eight key principles of quality management which is not auditable but do form the fundamental characteristics of quality management.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>कर्मचारी अपघात आणि दुखापत कमी होतात</li>
                        <li>कायदेशीर आणि नियामक अनुपालन</li>
                        <li>विमा प्रीमियम कमी होऊ शकतो</li>
                        <li>कर्मचारी समाधान आणि उत्पादकता वाढते</li>
                        <li>संस्थेची प्रतिष्ठा आणि विश्वासार्हता वाढते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 45001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 45001" />
                </section>
            </div>
        </div>
    );
};

export default ISO45001;